import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="spaces-section-toggle"
export default class extends Controller {

  static targets = ['header', 'body', 'input']

  connect(){
  }

  open(){
    this.bodyTarget.classList.add('open');
    this.headerTarget.classList.add('closed');
  }

  close(){
    this.bodyTarget.classList.remove('open');
    this.headerTarget.classList.remove('closed');
  }

}
